import renderChildNodes from "./renderChildNodes";
import Link from "./Components/Link";
import { useMemo } from "react";

export const defaultComponentsMap = {
  a: Link,
};

const DefaultWysiwyg = ({ content, componentsMap }) => {
  const componentsMapWithDefaultComponents = useMemo(() => {
    return {
      ...defaultComponentsMap,
      ...(componentsMap || {}),
    };
  }, [componentsMap]);

  return renderChildNodes(
    content.childNodes,
    content.data,
    componentsMapWithDefaultComponents
  );
};

export default DefaultWysiwyg;
